import React from 'react';
import { useSirenEntity } from '~/utility/BinSentry-ui-utility';
import { Link } from '~/lib/bn-material-ui';

export function BarnLink({ binHref, barnHref, ...linkProps }) {
  // use binHref to get the owner
  const { entity: binEntity } = useSirenEntity({ href: binHref });
  const ownerHref = binEntity?.getSubEntityByRel('https://api.binsentry.com/rel/bin-owner').href;

  // or use the barnHref directly
  const { entity: barnEntity } = useSirenEntity({ href: barnHref || ownerHref });

  if (!barnEntity) {
    return null;
  }

  const orgId = barnEntity.getLink('self').href;

  return (
    <Link
      href={`/customers/?organizationId=${encodeURIComponent(orgId)}`}
      {...linkProps}
    >
      {barnEntity.properties.name}
    </Link>
  );
}
